import { For } from 'solid-js';
import { SHEET_W_MM, SHEET_H_MM } from '../core/geometry';
import { CornerCropMarks } from './CornerCropMarks';
import { RegistrationMarks } from './RegistrationMarks';
import { SlotElement } from './SlotElement';
import type { Slot } from '../types';

export function SheetSVG(props: {
  slots: Slot[];
  highlightId?: number | null;
  onSlotClick?: (id: number) => void;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${SHEET_W_MM} ${SHEET_H_MM}`}
      width={`${SHEET_W_MM}mm`}
      height={`${SHEET_H_MM}mm`}
    >
      <rect width={SHEET_W_MM} height={SHEET_H_MM} fill="white" />
      <CornerCropMarks />
      <RegistrationMarks />
      <For each={props.slots}>
        {slot => (
          <SlotElement
            slot={slot}
            highlight={props.highlightId === slot.id}
            onClick={props.onSlotClick}
          />
        )}
      </For>
    </svg>
  );
}
